import React from 'react'
import SectionSeparator from '../../pb_section_separator/_section_separator'

const SectionSeparatorText = (props) => {
  return (
    <SectionSeparator
        {...props}
        text="Text Separator"
    />
  )
}

export default SectionSeparatorText
